import CidadeService from "@/services/CidadeService";

export const actions = {
  async listarCidades({ commit }) {
    await CidadeService.listar()
      .then((res) => {
        commit("setCidades", res.data);
      })
      .catch((e) => console.log(e));
  },
};

export default {};
